import { createRootRoute, Outlet } from '@tanstack/react-router';
import { useEffect } from 'react';
import { Toaster } from '@ludolio/shared-ui';
import { useAuthStore } from '@/stores/authStore';

const AUTH_RECHECK_THROTTLE_MS = 60_000;

export const Route = createRootRoute({
  component: RootLayout,
});

function RootLayout() {
  useEffect(() => {
    let lastCheckAt = Date.now();

    const recheckActiveSession = () => {
      if (document.visibilityState === 'hidden') return;

      const state = useAuthStore.getState();
      if (!state.isAuthenticated || state.isInitializing || state.isLoading) return;

      const now = Date.now();
      if (now - lastCheckAt < AUTH_RECHECK_THROTTLE_MS) return;

      lastCheckAt = now;
      void state.checkAuth();
    };

    window.addEventListener('focus', recheckActiveSession);
    document.addEventListener('visibilitychange', recheckActiveSession);

    return () => {
      window.removeEventListener('focus', recheckActiveSession);
      document.removeEventListener('visibilitychange', recheckActiveSession);
    };
  }, []);

  return (
    <>
      <Outlet />
      <Toaster richColors position="top-right" />
    </>
  );
}

